import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

type PdfPreviewFallbackProps = {
  pdfUrl: string;
  title: string | undefined;
};

export const PdfPreviewFallback = ({
  pdfUrl,
  title,
}: PdfPreviewFallbackProps) => {
  return (
    <div className="flex flex-col items-center gap-6 px-6 py-12 text-center">
      <h3 className="sr-only">{title}</h3>
      <Typography.Text>
        Couldn’t display the document.
        <br /> Download the agreement to view.
      </Typography.Text>
      <Button variant="secondary" asChild>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noreferrer"
          download="agreement.pdf"
        >
          Download the agreement
        </a>
      </Button>
    </div>
  );
};
